export const ActionTypes = {
    FETCH_WIDGET_DATA_PROGRESS: "detail/fetch_widget_data_progress",
    FETCH_WIDGET_DATA_SUCCESS: "detail/fetch_widget_data_success",
    FETCH_WIDGET_DATA_FAILED: "detail/fetch_widget_data_failed",
};
